import { useContext } from 'react';
import { SessionStateContext } from './SessionStateProvider';

export function useSessionStorage(key, defaultValue) {
  const [state, setState] = useContext(SessionStateContext);

  const value = state?.[key] ?? defaultValue;

  const update = (newValue) => {
    setState((prev) => ({
      ...prev,
      [key]: newValue
    }));
  };

  return [value, update];
}

export default useSessionStorage;